export const GET_VENDOR_REQUEST = 'GET_VENDOR_REQUEST';
export const GET_VENDOR_SUCCESS = 'GET_VENDOR_SUCCESS';
export const GET_VENDOR_FAILURE = 'GET_VENDOR_FAILURE';
 
export const CREATE_VENDOR_REQUEST = 'CREATE_VENDOR_REQUEST';
export const CREATE_VENDOR_SUCCESS = 'CREATE_VENDOR_SUCCESS';
export const CREATE_VENDOR_FAILURE = 'CREATE_VENDOR_FAILURE';
 
export const UPDATE_VENDOR_REQUEST = 'UPDATE_VENDOR_REQUEST';
export const UPDATE_VENDOR_SUCCESS = 'UPDATE_VENDOR_SUCCESS';
export const UPDATE_VENDOR_FAILURE = 'UPDATE_VENDOR_FAILURE';
 
export const DELETE_VENDOR_REQUEST = 'DELETE_VENDOR_REQUEST';
export const DELETE_VENDOR_SUCCESS = 'DELETE_VENDOR_SUCCESS';
export const DELETE_VENDOR_FAILURE = 'DELETE_VENDOR_FAILURE';
 
export const UPLOAD_VENDOR_REQUEST = 'UPLOAD_VENDOR_REQUEST';
export const UPLOAD_VENDOR_SUCCESS = 'UPLOAD_VENDOR_SUCCESS';
export const UPLOAD_VENDOR_FAILURE = 'UPLOAD_VENDOR_FAILURE';
 
export const MULTIDELETE_VENDOR_REQUEST = 'MULTIDELETE_VENDOR_REQUEST';
export const MULTIDELETE_VENDOR_SUCCESS = 'MULTIDELETE_VENDOR_SUCCESS';
export const MULTIDELETE_VENDOR_FAILURE = 'MULTIDELETE_VENDOR_FAILURE';
 
 
export const GET_UNIT_BASE_VENDOR_REQUEST = 'GET_UNIT_BASE_VENDOR_REQUEST';
export const GET_UNIT_BASE_VENDOR_SUCCESS = 'GET_UNIT_BASE_VENDOR_SUCCESS';
export const GET_UNIT_BASE_VENDOR_FAILURE = 'GET_UNIT_BASE_VENDOR_FAILURE';
 
export const CREATE_SINGLE_AUDIT_REQUEST = 'UPDATE_SINGLE_AUDIT_REQUEST';
export const CREATE_SINGLE_AUDIT_SUCCESS = 'UPDATE_SINGLE_AUDIT_SUCCESS';
export const CREATE_SINGLE_AUDIT_FAILURE = 'UPDATE_SINGLE_AUDIT_FAILURE';
 
export const GET_AUDIT_REQUEST = 'GET_AUDIT_REQUEST';
export const GET_AUDIT_SUCCESS = 'GET_AUDIT_SUCCESS';
export const GET_AUDIT_FAILURE = 'GET_AUDIT_FAILURE';
 
 
export const GET_TEMPLATE_MAPPING_REQUEST = 'GET_TEMPLATE_MAPPING_REQUEST';
export const GET_TEMPLATE_MAPPING_SUCCESS = 'GET_TEMPLATE_MAPPING_SUCCESS';
export const GET_TEMPLATE_MAPPING_FAILURE = 'GET_TEMPLATE_MAPPING_FAILURE';
 
export const CREATE_TEMPLATE_MAPPING_REQUEST = 'CREATE_TEMPLATE_MAPPING_REQUEST';
export const CREATE_TEMPLATE_MAPPING_SUCCESS = 'CREATE_TEMPLATE_MAPPING_SUCCESS';
export const CREATE_TEMPLATE_MAPPING_FAILURE = 'CREATE_TEMPLATE_MAPPING_FAILURE';
 
export const UPDATE_TEMPLATE_MAPPING_REQUEST = 'UPDATE_TEMPLATE_MAPPING_REQUEST';
export const UPDATE_TEMPLATE_MAPPING_SUCCESS = 'UPDATE_TEMPLATE_MAPPING_SUCCESS';
export const UPDATE_TEMPLATE_MAPPING_FAILURE = 'UPDATE_TEMPLATE_MAPPING_FAILURE';
 
export const DELETE_TEMPLATE_MAPPING_REQUEST = 'DELETE_TEMPLATE_MAPPING_REQUEST';
export const DELETE_TEMPLATE_MAPPING_SUCCESS = 'DELETE_TEMPLATE_MAPPING_SUCCESS';
export const DELETE_TEMPLATE_MAPPING_FAILURE = 'DELETE_TEMPLATE_MAPPING_FAILURE';
 
export const MULTIDELETE_TEMPLATE_MAPPING_REQUEST = 'MULTIDELETE_TEMPLATE_MAPPING_REQUEST';
export const MULTIDELETE_TEMPLATE_MAPPING_SUCCESS = 'MULTIDELETE_TEMPLATE_MAPPING_SUCCESS';
export const MULTIDELETE_TEMPLATE_MAPPING_FAILURE = 'MULTIDELETE_TEMPLATE_MAPPING_FAILURE';
 
export const VENDOR_LOGIN_REQUEST = 'VENDOR_LOGIN_REQUEST';
export const VENDOR_LOGIN_SUCCESS = 'VENDOR_LOGIN_SUCCESS';
export const VENDOR_LOGIN_FAILURE = 'VENDOR_LOGIN_FAILURE';
 
export const VENDOR_FORGOT_PASSWORD_REQUEST = 'VENDOR_FORGOT_PASSWORD_REQUEST';
export const VENDOR_FORGOT_PASSWORD_SUCCESS = 'VENDOR_FORGOT_PASSWORD_SUCCESS';
export const VENDOR_FORGOT_PASSWORD_FAILURE = 'VENDOR_FORGOT_PASSWORD_FAILURE';
 
export const GET_VENDOR_AUDIT_DETAILS_REQUEST = 'GET_VENDOR_AUDIT_DETAILS_REQUEST';
export const GET_VENDOR_AUDIT_DETAILS_SUCCESS = 'GET_VENDOR_AUDIT_DETAILS_SUCCESS';
export const GET_VENDOR_AUDIT_DETAILS_FAILURE = 'GET_VENDOR_AUDIT_DETAILS_FAILURE';
 
export const UPDATE_VENDOR_AUDIT_DETAILS_REQUEST = 'UPDATE_VENDOR_AUDIT_DETAILS_REQUEST';
export const UPDATE_VENDOR_AUDIT_DETAILS_SUCCESS = 'UPDATE_VENDOR_AUDIT_DETAILS_SUCCESS';
export const UPDATE_VENDOR_AUDIT_DETAILS_FAILURE = 'UPDATE_VENDOR_AUDIT_DETAILS_FAILURE';
 
export const GET_CLIENT_WISE_AUDIT_REQUEST = 'GET_CLIENT_WISE_AUDIT_REQUEST';
export const GET_CLIENT_WISE_AUDIT_SUCCESS = 'GET_CLIENT_WISE_AUDIT_SUCCESS';
export const GET_CLIENT_WISE_AUDIT_FAILURE = 'GET_CLIENT_WISE_AUDIT_FAILURE';
 
export const UPDATE_AUDIT_DETAILS_REQUEST = 'UPDATE_AUDIT_DETAILS_REQUEST';
export const UPDATE_AUDIT_DETAILS_SUCCESS = 'UPDATE_AUDIT_DETAILS_SUCCESS';
export const UPDATE_AUDIT_DETAILS_FAILURE = 'UPDATE_AUDIT_DETAILS_FAILURE';
 
export const GET_AUDIT_DETAILS_REQUEST = 'GET_AUDIT_DETAILS_REQUEST';
export const GET_AUDIT_DETAILS_SUCCESS = 'GET_AUDIT_DETAILS_SUCCESS';
export const GET_AUDIT_DETAILS_FAILURE = 'GET_AUDIT_DETAILS_FAILURE';
 
export const VENDOR_LOGIN_RELEASE_REQUEST = 'VENDOR_LOGIN_RELEASE_REQUEST';
export const VENDOR_LOGIN_RELEASE_SUCCESS = 'VENDOR_LOGIN_RELEASE_SUCCESS';
export const VENDOR_LOGIN_RELEASE_FAILURE = 'VENDOR_LOGIN_RELEASE_FAILURE';
 
 
export const FETCH_ATTACHMENT_FILE_REQUEST = 'FETCH_ATTACHMENT_FILE_REQUEST';
export const FETCH_ATTACHMENT_FILE_SUCCESS = 'FETCH_ATTACHMENT_FILE_SUCCESS';
export const FETCH_ATTACHMENT_FILE_FAILURE = 'FETCH_ATTACHMENT_FILE_FAILURE';
 
export const DOWNLOAD_ATTACHMENT_FILE_REQUEST = 'DOWNLOAD_ATTACHMENT_FILE_REQUEST';
export const DOWNLOAD_ATTACHMENT_FILE_SUCCESS = 'DOWNLOAD_ATTACHMENT_FILE_SUCCESS';
export const DOWNLOAD_ATTACHMENT_FILE_FAILURE = 'DOWNLOAD_ATTACHMENT_FILE_FAILURE';
 
export const DELETE_ATTACHMENT_FILE_REQUEST = 'DELETE_ATTACHMENT_FILE_REQUEST';
export const DELETE_ATTACHMENT_FILE_SUCCESS = 'DELETE_ATTACHMENT_FILE_SUCCESS';
export const DELETE_ATTACHMENT_FILE_FAILURE = 'DELETE_ATTACHMENT_FILE_FAILURE';
 
export const VENDOR_UPDATE_REQUEST = 'VENDOR_UPDATE_REQUEST';
export const VENDOR_UPDATE_SUCCESS = 'VENDOR_UPDATE_SUCCESS';
export const VENDOR_UPDATE_FAILURE = 'VENDOR_UPDATE_FAILURE';
 
export const VENDOR_PROFILE_UPLOAD_REQUEST = 'VENDOR_PROFILE_UPLOAD_REQUEST';
export const VENDOR_PROFILE_UPLOAD_SUCCESS = 'VENDOR_PROFILE_UPLOAD_SUCCESS';
export const VENDOR_PROFILE_UPLOAD_FAILURE = 'VENDOR_PROFILE_UPLOAD_FAILURE';
 
export const VENDOR_PROFILE_FETCH_REQUEST = 'VENDOR_PROFILE_FETCH_REQUEST';
export const VENDOR_PROFILE_FETCH_SUCCESS = 'VENDOR_PROFILE_FETCH_SUCCESS';
export const VENDOR_PROFILE_FETCH_FAILURE = 'VENDOR_PROFILE_FETCH_FAILURE';
 
export const VENDOR_GET_PROFILE_REQUEST = 'VENDOR_GET_PROFILE_REQUEST';
export const VENDOR_GET_PROFILE_SUCCESS = 'VENDOR_GET_PROFILE_SUCCESS';
export const VENDOR_GET_PROFILE_FAILURE = 'VENDOR_GET_PROFILE_FAILURE';

export const DOWNLOAD_AUDIT_REQUEST = 'DOWNLOAD_AUDIT_REQUEST';
export const DOWNLOAD_AUDIT_SUCCESS = 'DOWNLOAD_AUDIT_SUCCESS';
export const DOWNLOAD_AUDIT_FAILURE = 'DOWNLOAD_AUDIT_FAILURE';
